var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop-programming-code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop-programming-code",
    transform: "translate(3.001196, 3.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9988042,2 L16.9988042,9.5 C16.9988042,10.3284271 16.3272313,11 15.4988042,11 L2.49880422,11 C1.6703771,11 0.998804223,10.3284271 0.998804223,9.5 L0.998804223,2 C0.998804223,0.8954305 1.89423472,0 2.99880422,0 L14.9960858,0 C16.0995664,0 16.9988042,0.879385189 16.9988042,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9978642,18 L1.99974422,18 C1.3722651,18 0.781169427,17.7054787 0.403292328,17.2045406 C0.025415229,16.7036025 -0.0954207727,16.0543439 0.0769342231,15.451 L1.14124422,11.72532 C1.26389028,11.2959893 1.656299,11 2.10280422,11 L15.8948042,11 C16.3412983,11 16.7336912,11.296 16.8563342,11.72532 L17.9206742,15.451 C18.0930292,16.0543439 17.9721932,16.7036025 17.5943161,17.2045406 C17.216439,17.7054787 16.6253433,18 15.9978642,18 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.99880422,
    y1: 15,
    x2: 10.9988042,
    y2: 15,
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/laptop.03564887f66c2cfb07ced6ade4c8ff2e.svg";
export { MemoForwardRef as ReactComponent };